import { axios } from 'lib';
import { useQuery } from 'react-query';

const defaultQueryParams = {
  queryKey: ['company'],
  queryOptions: {},
};

const getFACompanyByFacID = async (faId, facId) => {
  const { data } = await axios.get(`/api/framework_agreements/${faId}/companies/${facId}`);

  return data;
};

export const useCompany = (faId, facId, queryParams = {}) => {
  const { queryKey, queryOptions } = {
    ...defaultQueryParams,
    ...queryParams,
  };

  return useQuery([...queryKey, facId], () => getFACompanyByFacID(faId, facId), {
    initialData: { company_name: 'Company', FA: {} },
    ...queryOptions,
  });
};
